export enum CardBehaviorType {
  INITIAL = 'initial',
  TRANSITIONING = 'transitioning',
  EXPANDED = 'expanded',
  STEP = 'step',
}
